<template>
  <div>
    <BetPlacedAlertConfig />
  </div>
</template>

<script>
import BetPlacedAlertConfig from "./BetPlacedAlertConfig.vue";

export default {
  components: {
    BetPlacedAlertConfig,
  },
};
</script>
